/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.DocsAndFormsKiosk {
    angular.module('meevo.plugins.docsAndFormsKiosk', []);
}
